// ===== Packages =====

import {
    GoogleAuthProvider,
    GithubAuthProvider,
    TwitterAuthProvider,
    FacebookAuthProvider,
    UserCredential,
    AuthCredential,
}                               from 'firebase/auth';

// ===== Constants =====

import {
    SUPPORT_EMAIL_ADDRESS,
}                               from '../constants/generalConstants';

type ExtractedCredential = {
  credential: AuthCredential | null;
  accessToken?: string;
  providerId?: string | null;
};
function extractCredential(result: UserCredential | null): ExtractedCredential {
    if (!result) return { credential: null };

    const { providerId } = result;
    let credential: AuthCredential | null = null;

    switch (providerId) {
    case GoogleAuthProvider.PROVIDER_ID:
        credential = GoogleAuthProvider.credentialFromResult(result);
        break;
    case GithubAuthProvider.PROVIDER_ID:
        credential = GithubAuthProvider.credentialFromResult(result);
        break;
    case TwitterAuthProvider.PROVIDER_ID:
        credential = TwitterAuthProvider.credentialFromResult(result);
        break;
    case FacebookAuthProvider.PROVIDER_ID:
        credential = FacebookAuthProvider.credentialFromResult(result);
        break;
    default:
        throw Error(`Encountered an unrecognizable sign-in provider. Please reach out to verascope support at: ${SUPPORT_EMAIL_ADDRESS}.`);
    }

    const accessToken = (credential as any)?.accessToken
    ?? (credential as any)?.oauthAccessToken
    ?? undefined;

    return { credential, accessToken, providerId };
}

export default extractCredential;
